// Close hamburger menu after click on menu items
$(document).ready(function () {
  $(".menu-drawer-container .list-menu__item").on("click", function () {
    $(".menu-drawer-container").removeAttr("open");
    $(".menu-drawer-container summary").attr("aria-expanded", "false");
    $(".menu-drawer-container").removeClass("menu-opening");
  });
});

// Opening one accordion and close all other accordions
$(document).ready(function () {
  $(".accordion details").on("click", function () {
    $(this).attr("open");
    $(this).parent(".accordion").siblings().find("details").removeAttr("open");
  });
});

// Smooth Scrolling JS start
jQuery(document).ready(function ($) {
  let scrollOffset = 60;
  const params = new URLSearchParams(window.location.search);
  const skipAutoScrollOnce = (() => {
    try {
      const v = sessionStorage.getItem("bnSkipAutoScrollOnce") === "1";
      if (v) sessionStorage.removeItem("bnSkipAutoScrollOnce");
      return v;
    } catch (e) {
      return false;
    }
  })();

  const isBlogNewsletterSuccess =
    params.get("customer_posted") === "true" &&
    typeof window.location.hash === "string" &&
    window.location.hash.indexOf("#BlogNewsletterForm-") === 0;

  if (window.location.hash && !isBlogNewsletterSuccess && !skipAutoScrollOnce) {
    // smooth scroll to the anchor id
    jQuery("html,body").animate({
      scrollTop: jQuery(window.location.hash).offset().top - scrollOffset,
    });
  } else if (!skipAutoScrollOnce && !isBlogNewsletterSuccess) {
    setTimeout(function () {
      scroll(0, 0);
    }, 1);
  }
  jQuery("a[href*=\\#]:not([href$=\\#])").on("click", function (evt) {
    evt.preventDefault();
    var url = jQuery(this).attr("href");
    var id = url.substring(url.lastIndexOf("#"));
    if (jQuery(id).length > 0) {
      jQuery("html, body").animate(
        {
          scrollTop: jQuery(id).offset().top - scrollOffset,
        },
        500
      );
    } else {
      window.location.href = url;
    }
  });
});
// Smooth Scrolling JS end

// Blog article: copy share URL (avoid broken onclick when JSON string contains `"`)
function articleShareCopyToClipboard(button) {
  var url = button.getAttribute("data-article-share-url");
  if (!url) return;
  var originalLabel = button.textContent;
  function showCopied() {
    button.textContent = "Copied!";
    setTimeout(function () {
      button.textContent = originalLabel;
    }, 2000);
  }
  function fallbackCopy() {
    var t = document.createElement("textarea");
    t.value = url;
    t.setAttribute("readonly", "");
    t.style.position = "fixed";
    t.style.left = "-9999px";
    document.body.appendChild(t);
    t.focus();
    t.select();
    try {
      document.execCommand("copy");
      showCopied();
    } catch (e) {
      button.textContent = "Could not copy";
      setTimeout(function () {
        button.textContent = originalLabel;
      }, 2000);
    }
    document.body.removeChild(t);
  }
  if (navigator.clipboard && typeof navigator.clipboard.writeText === "function") {
    navigator.clipboard.writeText(url).then(showCopied).catch(fallbackCopy);
  } else {
    fallbackCopy();
  }
}

$(document).on("click", ".share-copy-btn", function () {
  articleShareCopyToClipboard(this);
});

// Blog article: floating share strip (fixed until section end)
(function () {
  function initArticleShareStrip() {
    var strip = document.querySelector("[data-article-share-strip].article-share-strip--floating");
    var container = document.querySelector(".article-template .article-information");
    if (!strip || !container) return;

    function getTopOffset() {
      var headerOffset = 0;
      try {
        var headerWrapper = document.querySelector(".section-header .header-wrapper");
        if (headerWrapper) {
          headerOffset = headerWrapper.getBoundingClientRect().height || 0;
        } else {
          var cssVar = getComputedStyle(document.body).getPropertyValue("--header-wrapper-height");
          var v = parseFloat(cssVar);
          if (!isNaN(v)) headerOffset = v;
        }
      } catch (e) {}
      return Math.round(headerOffset + 40);
    }
    var raf = 0;

    function updateLeft() {
      var containerRect = container.getBoundingClientRect();
      var left = containerRect.left - 20;
      strip.style.left = left + "px";
    }

    function updatePosition() {
      raf = 0;
      if (window.innerWidth < 1200) {
        strip.classList.remove("is-fixed");
        strip.classList.remove("is-at-end");
        strip.style.top = "";
        strip.style.bottom = "";
        strip.style.left = "";
        return;
      }

      var topOffset = getTopOffset();
      var containerRect = container.getBoundingClientRect();
      var stripRect = strip.getBoundingClientRect();

      var containerTop = containerRect.top + window.scrollY;
      var containerBottom = containerRect.bottom + window.scrollY;
      var scrollTop = window.scrollY;

      var fixedTop = scrollTop + topOffset;
      var maxFixedTop = containerBottom - stripRect.height;

      strip.classList.remove("is-fixed");
      strip.classList.remove("is-at-end");

      if (fixedTop <= containerTop) {
        strip.style.top = "0px";
        strip.style.bottom = "";
      } else if (fixedTop >= maxFixedTop) {
        strip.classList.add("is-at-end");
        strip.style.top = "";
        strip.style.bottom = "0px";
      } else {
        strip.classList.add("is-fixed");
        strip.style.top = topOffset + "px";
        strip.style.bottom = "";
      }
    }

    function onScrollOrResize() {
      if (raf) return;
      raf = window.requestAnimationFrame(function () {
        updateLeft();
        updatePosition();
      });
    }

    updateLeft();
    updatePosition();
    window.addEventListener("scroll", onScrollOrResize, { passive: true });
    window.addEventListener("resize", onScrollOrResize);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initArticleShareStrip);
  } else {
    initArticleShareStrip();
  }
})();
